import axios from "axios"
import NProgress from "nprogress"

const apiUser = axios.create({
  baseURL: "https://api.icap-maker.com/",
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  }
})

apiUser.interceptors.request.use(config => {
  NProgress.start()
  return config
})

apiUser.interceptors.response.use(response => {
  NProgress.done()
  return response
})

export default {
  get_NUsers() {
    return apiUser.get("/User/Users/")
  },
  postUser(user) {
    return apiUser.post("/User/", user)
  },
  SaveTest(_test) {
    return apiUser({
      method: "post",
      url: "/User/SaveUserTest/",
      data: {
        _test: "mysystem sends"
      }
    })
  },
  Save(user, fields) {
    return apiUser({
      method: "post",
      url: "/User/SaveUser/",
      data: {
        _up: { UserProfileID: user.UserProfileID },
        _newValues: fields
      }
    }).then(function(response) {
      user.UserProfileID = response.data["SaveUserResult"]
    })
  },
  Delete(user) {
    return apiUser({
      method: "post",
      url: "/User/Delete/",
      data: {
        _up: { UserProfileID: user.UserProfileID }
      }
    }) //.then(function(response) {
    //   user.UserProfileID = response.data["SaveUserResult"]
    // })
  },
  Authenticate(username, password) {
    return apiUser({
      method: "post",
      url: "/User/Authenticate/",
      data: {
        _username: username,
        _password: password
      }
    })
    // .then(function(response) {
    //   alert(response.data["AuthenticateResult"].UserProfileID)
    // })
    // .catch(error => {
    //   alert(error.message)
    // })
  }
}
